var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2055 18.3333C9.07629 18.3333 7.97546 18.3208 6.88629 18.2983C5.49296 18.2708 4.52879 17.3674 4.37129 15.9408C4.10879 13.5741 3.65962 7.99575 3.65546 7.93992C3.62712 7.59575 3.88379 7.29409 4.22796 7.26659C4.56712 7.25742 4.87379 7.49575 4.90129 7.83909C4.90546 7.89575 5.35379 13.4549 5.61379 15.8033C5.70296 16.6141 6.14046 17.0324 6.91212 17.0483C8.99546 17.0924 11.1213 17.0949 13.413 17.0533C14.233 17.0374 14.6763 16.6274 14.768 15.7974C15.0263 13.4691 15.4763 7.89575 15.4813 7.83909C15.5088 7.49575 15.813 7.25575 16.1538 7.26659C16.498 7.29492 16.7546 7.59575 16.7271 7.93992C16.7221 7.99659 16.2705 13.5891 16.0105 15.9349C15.8488 17.3908 14.8871 18.2766 13.4355 18.3033C12.3246 18.3224 11.253 18.3333 10.2055 18.3333Z",
    fill: "#DB1818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2567 5.82446H3.125C2.78 5.82446 2.5 5.54446 2.5 5.19946C2.5 4.85446 2.78 4.57446 3.125 4.57446H17.2567C17.6017 4.57446 17.8817 4.85446 17.8817 5.19946C17.8817 5.54446 17.6017 5.82446 17.2567 5.82446Z",
    fill: "#DB1818"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5335 5.82437C13.5852 5.82437 12.7618 5.14854 12.5752 4.21854L12.3727 3.2052C12.3302 3.05104 12.1543 2.91687 11.9543 2.91687H8.42682C8.22682 2.91687 8.05099 3.05104 8.00016 3.24354L7.80599 4.21854C7.62016 5.14854 6.79599 5.82437 5.84766 5.82437C5.50266 5.82437 5.22266 5.54437 5.22266 5.19937C5.22266 4.85437 5.50266 4.57437 5.84766 4.57437C6.20266 4.57437 6.51099 4.32104 6.58099 3.9727L6.78349 2.95937C6.98932 2.1827 7.66182 1.66687 8.42682 1.66687H11.9543C12.7193 1.66687 13.3918 2.1827 13.5893 2.92187L13.801 3.9727C13.8702 4.32104 14.1785 4.57437 14.5335 4.57437C14.8785 4.57437 15.1585 4.85437 15.1585 5.19937C15.1585 5.54437 14.8785 5.82437 14.5335 5.82437Z",
    fill: "#DB1818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/iconDelete.6a5a2540d9a2dc40221daa3da721016a.svg";
export { ForwardRef as ReactComponent };